import { createBrowserRouter } from "react-router-dom";

import { BillProvider } from "../Components/Contexts/Bill";

import Login from "./Login/Login";
import InboxLoader from "./InboxPage/InboxLoader";
import InboxPage from "./InboxPage/InboxPage";
import FilePanel from "./Grouping/FilePanel";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    element: <InboxLoader />,
    children: [
      {
        path: "inbox",
        element: (
          <BillProvider>
            <InboxPage />
          </BillProvider>
        ),
      },
    ],
  },
  {
    loader: async ({ request }) => {
      const url = new URL(request.url);
      const bill_id = url.searchParams.get("bill_id");
      if (!bill_id) {
        throw new Response("Missing required parameters", { status: 400 });
      }
      return { bill_id };
    },
    path: "/grouping",
    element: (
      <BillProvider>
        <FilePanel />
      </BillProvider>
    ),
  },
]);

export default router;
